/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './Dot.scss';

import React from 'react';

const Dot = ({ sizeInPixels }) => {
  return (
    <svg width={sizeInPixels * 2} height={sizeInPixels * 2} className={'dot'}>
      <circle
        cx={`${sizeInPixels}px`}
        cy={`${sizeInPixels}px`}
        r={`${sizeInPixels}px`}
      />
    </svg>
  );
};

export default Dot;
